<template>
	<div class="content margin-bottom">
		<Loader v-if="loading" />
		<h1>Batch operate Orders</h1>
		<div class="message">
			<ul>
				<li class="label" v-for="message in messages" v-text="message"></li>
			</ul>
		</div>
		<div class="control">
			<textarea cols="100" rows="10"
						placeholder="Add order IDs in separate lines" v-model="orderIds">
			</textarea>
			<br>
			<button class="margin-right" @click="batchCreateMirrorInUniconta()">Mirror orders in uniconta</button>
			<button class="margin-right" @click="batchCreateInvoiceInUniconta()">Create invoice in uniconta</button>
			<button class="margin-right" @click="batchOperateBalanceUniconta()">Balance uniconta</button>
			<button class="margin-right" @click="batchOperateDlvRun()">DLV Run</button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'

export default {
  data: () => {
    return {
      loading: false,
      orderIds: '',
      messages: []
    }
  },
  methods: {
    batchCreateMirrorInUniconta () {
      this.messages = []
      if (!this.getConfirmation()) {
        return
      }
      var orderIds = this.getOrderIds()
      var that = this
      _.each(orderIds, function (orderId) {
        that.createMirrorInUniconta(orderId)
      })
    },
    batchOperateBalanceUniconta () {
      this.messages = []
      if (!this.getConfirmation()) {
        return
      }
      var orderIds = this.getOrderIds()
      var that = this
      _.each(orderIds, function (orderId, i) {
        setTimeout(function () {
          that.balanceUniconta(orderId, () => {
            that.handleDoneBalancing(orderId)
          })
        }, 3000 * i)
      })
    },
    batchCreateInvoiceInUniconta () {
      this.messages = []
      if (!this.getConfirmation()) {
        return
      }
      var orderIds = this.getOrderIds()
      var that = this
      _.each(orderIds, function (orderId) {
        that.createInvoiceInUniconta(orderId)
      })
    },
    batchOperateDlvRun () {
      this.messages = []
      if (!this.getConfirmation()) {
        return
      }
      var orderIds = this.getOrderIds()
      var that = this
      _.each(orderIds, function (orderId) {
        that.runDlv(orderId, () => {
          this.handleDoneDlvRun(orderId)
        })
      })
    },
    getOrderIds () {
      return _.uniq(this.orderIds.split('\n'))
    },
    getConfirmation () {
      if (_.isEmpty(this.orderIds)) {
        alert('You must enter at least 1 order id')
        return false
      }
      return confirm('Are you sure you want to continue?')
    },
    createMirrorInUniconta (orderId) {
      this.validateMirroring(orderId, (reference) => {
        this.unicontaMirror(orderId, reference, () => {
          this.handleDoneMirroring(orderId)
        })
      })
    },
    balanceUniconta (orderId, callback) {
      Vue.api.post('order/' + orderId + '/uniconta/balance', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => callback(orderId)
      })
    },
    runDlv (orderId, callback) {
      Vue.api.post('order/' + orderId + '/dlv/process', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        error: (error) => this.messages.push('Error !!! ' + error.data.message || ''),
        callback: () => this.messages.push('Done DLV run for order with ID: ' + orderId)
      })
    },
    handleDoneMirroring (orderId) {
      this.messages.push('Done mirroring order with ID: ' + orderId)
    },
    handleDoneInvoicing (orderId) {
      this.messages.push('Done invoicing order with ID: ' + orderId)
    },
    handleDoneBalancing (orderId) {
      this.messages.push('Done balancing order with ID: ' + orderId)
    },
    validateMirroring (orderId, callback) {
      var reference = orderId // prompt('Please choose "Our reference"', this.$route.params.id);
      if (reference) {
        Vue.api.post('order/' + orderId + '/uniconta/mirror/validate', {
          reference: reference
        }, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: (response) => {
            if (response.require_verification) {
              if (confirm(response.message)) {
                callback(orderId, reference)
              } else {
                this.messages.push('Cancelled mirroring order with ID: ' + orderId)
              }
            } else {
              callback(orderId, reference)
            }
          }
        })
      }
    },
    unicontaMirror (orderId, reference, callback) {
      Vue.api.post('v2/order/' + orderId + '/uniconta/mirror', {
        reference: reference
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => callback(orderId)
      })
    },
    validateInvoiceInUniconta (orderId, callback) {
      Vue.api.post('order/' + orderId + '/uniconta/invoice/validate', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: (response) => {
          if (response.require_verification) {
            if (confirm(response.message)) {
              callback(orderId)
            } else {
              this.messages.push('Cancelled invoicing order with ID: ' + orderId)
            }
          } else {
            callback(orderId)
          }
        }
      })
    },
    createInvoiceInUniconta (orderId) {
      this.validateMirroring(orderId, (reference) => {
        this.unicontaMirror(orderId, reference, () => {
          this.validateInvoiceInUniconta(orderId, () => {
            this.createInvoice(orderId, () => {
              this.handleDoneInvoicing(orderId)
            })
          })
        })
      })
    },
    createInvoice (orderId, callback) {
      Vue.api.post('order/' + orderId + '/uniconta/invoice', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => callback()
      })
    }
  }
}
</script>

<style scoped>

</style>
